export default "__VITE_ASSET__98ef15fd__"